
    <a
      class="LinkElement"
      *ngIf="link && !external"
      [routerLink]="link"
      [queryParams]="queryParams"
      [fragment]="fragment"
      [target]="newTab ? '_blank' : undefined"
      [attr.itemprop]="itemprop"
      [attr.itemtype]="itemtype"
      [rel]="allRel"
    >
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </a>
    <!--
      External links always open in a new tab for convenience.
    -->
    <a
      class="LinkElement"
      *ngIf="link && external"
      [href]="link"
      [target]="'_blank'"
      [rel]="allRel"
      [attr.itemprop]="itemprop"
      [attr.itemtype]="itemtype"
    >
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </a>

    <button
      *ngIf="!link"
      class="LinkElement"
      type="button"
      [attr.disabled]="disabled ? true : null"
    >
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </button>

    <ng-template #content>
      <div
        class="LinkInner"
        [attr.data-icon]="iconName ? true : false"
        [attr.data-icon-position]="iconPosition"
      >
        <div
          class="LinkIcon"
          *ngIf="iconName"
          [attr.data-icon-position]="iconPosition"
        >
          <fl-icon
            [name]="iconName"
            [color]="iconColor"
            [size]="iconSize"
          ></fl-icon>
        </div>
        <div class="LinkText"><ng-content></ng-content></div>
      </div>
    </ng-template>
  